/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_LoadingInputs */

const en_carrier_notices_loading = /** @type {(inputs: Carrier_Notices_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading carrier notices...`)
};

const es_carrier_notices_loading = /** @type {(inputs: Carrier_Notices_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando avisos de transportistas...`)
};

/**
* | output |
* | --- |
* | "Loading carrier notices..." |
*
* @param {Carrier_Notices_LoadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_loading = /** @type {((inputs?: Carrier_Notices_LoadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_LoadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_loading(inputs)
	return es_carrier_notices_loading(inputs)
});